import { render, staticRenderFns } from "./ServiceButton.vue?vue&type=template&id=9f3c6792&scoped=true&"
import script from "./ServiceButton.vue?vue&type=script&lang=js&"
export * from "./ServiceButton.vue?vue&type=script&lang=js&"
import style0 from "./ServiceButton.vue?vue&type=style&index=0&id=9f3c6792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3c6792",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
